import { render, staticRenderFns } from "./ProductAttributeGroup.vue?vue&type=template&id=cdd7de80&"
import script from "./ProductAttributeGroup.vue?vue&type=script&lang=js&"
export * from "./ProductAttributeGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports